import * as types from 'constants/ActionTypes';
import { ANSWERED, OPEN, READ, SENT, TO_BE_SENT } from 'constants/InterventionConstants';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  accepted: number,
 *  rejected: number,
 *  answered: number,
 *  sent: number,
 *  read: number,
 *  notSent: number,
 * }} DealerInterventionsStatisticsReducer
 */
/** @type {DealerInterventionsStatisticsReducer} */
const initialState = { accepted: 0, rejected: 0, answered: 0, sent: 0, read: 0, notSent: 0 };

/**
 * @param {import('modules/statistics/types').InterventionStatusReducer} interventionStats
 * @param {number} initialValue
 * @param  {...import("@arhs-fleetback/types/entities/interventions").InterventionStatus} statuses
 * @returns {number}
 */
const getValue = (interventionStats, initialValue, ...statuses) => {
  const interventionStatuses = [interventionStats.status, interventionStats.statusBeforeClose];
  const isAvailable = statuses.some(status => interventionStatuses.includes(status));
  return initialValue + (isAvailable ? interventionStats.id : 0);
};

/**
 *
 * @param {DealerInterventionsStatisticsReducer} _
 * @param {import('modules/statistics/types').FetchInterventionStatusStatsSuccessAction} action
 * @returns {DealerInterventionsStatisticsReducer}
 */
const updateAllData = (_, { payload }) =>
  payload.content.reduce(
    (acc, item) => ({
      accepted: acc.accepted + item.acceptedOn,
      rejected: acc.rejected + item.rejectedOn,
      answered: getValue(item, acc.answered, ANSWERED),
      sent: getValue(item, acc.sent, SENT),
      read: getValue(item, acc.read, READ),
      notSent: getValue(item, acc.notSent, TO_BE_SENT, OPEN),
    }),
    { accepted: 0, rejected: 0, answered: 0, sent: 0, read: 0, notSent: 0 }
  );

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_INTERVENTION_STATUS_STATS_SUCCESS]: updateAllData,
});
